import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import QuanLyThuChiNgoaiLeApi from "../../../../../service/quanLyThuChiNgoaiLeApi";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import { useSelector, useDispatch } from "react-redux";
import {
  getListQuanLyThuChiNgoaiLe,
  updateDataSearch,
} from "../../../../../actions/QuanLyThuChiNgoaiLe";
import { currentDate } from "utils/formatDate";
import { formatDayMonth } from "utils/formatDate";
import { convertToNumber } from "utils/numberExtension";
import { pushNotification } from "utils/notifications";
import userApi from "../../../../../service/userApi";
import DateTimePicker from "../../../../../components/GenericComponent/DateTimePicker";
import { convertDate } from "utils/formatDate";
import ThangNamPhanBo from "../../ThangNamPhanBo";
import { currentDateV2 } from "utils/formatDate";
import CauHinhApi from "service/cauHinhApi";

export const ModalThemMoiChiNgoaiLe = (props) => {
  //Code
  const dataSearch = useSelector(
    (state) => state.dataSearchQuanLyThuChiNgoaiLe,
  );
  const dispatch = useDispatch();
  const [isSubbmit, setIsSubmit] = useState(false);
  const [usePhanBoChiPhi, setUsePhanBoChiPhi] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [tempValue, setTempValue] = useState(""); // Giá trị tạm lưu
  const [phanBoData, setPhanBoData] = useState([]);

  const [phanBo, setPhanBo] = useState(false);
  const [soThang, setSoThang] = useState(0);
  const [tuThang, setTuThang] = useState(1);
  const [tuNam, setTuNam] = useState(new Date().getFullYear());

  const handleCheckboxChange = (event) => {
    setDataChiNgoaiLe((prevState) => ({
      ...prevState,
      isLoiNhuan: !prevState.isLoiNhuan,
    }));
  };

  const setSoLuongPhanBoChiPhi = (event) => {
    setSoThang(event);
  };

  const updatePhanBoData = (thang, nam, value) => {
    setPhanBoData((prevData) => {
      const newData = [...prevData];
      const index = newData.findIndex(
        (item) => item.thang === thang && item.nam === nam,
      );
      if (index !== -1) {
        // Nếu tìm thấy tháng, cập nhật số tiền
        newData[index] = { ...newData[index], sotien: value };
      }
      return newData;
    });
  };

  const setPhanBoChiPhi = (event) => {
    setPhanBo(event);
    setSoThang(0);
  };

  const initData = {
    thuchiId: props.thuchiId,
    ngaythuchi: currentDate(),
    nhanviennhantien: "",
    nguoinop: "",
    sotien: 0,
    loaiphieu: 0,
    ghichu: "",
    isLoiNhuan: true,
    isPhanBoChiPhi: false,
    soThang: 0,
    tuThang: 1,
    tuNam: 9999,
    dataPhanBo: [],
  };
  const [dataChiNgoaiLe, setDataChiNgoaiLe] = useState(initData);

  const updateDropdown = (field) => (e) => {
    setDataChiNgoaiLe({
      ...dataChiNgoaiLe,
      [field]: e.target.value,
    });
    if (e.target.value === "" || e.target.value === "0") {
      setErrors({
        ...errors,
        nhanviennhantien: "Chọn nhân viên đưa tiền",
      });
    } else {
      setErrors({
        ...errors,
        nhanviennhantien: "",
      });
    }
  };

  useEffect(() => {
    if (!loaded) {
      QuanLyThuChiNgoaiLeApi.cauHinhPhanBoChiPhiNgoaiLe().then((response) => {
        setUsePhanBoChiPhi(response.data);
      });
      setLoaded(true);
    }
    if (props.thuchiId === 0) {
      CauHinhApi.getTimeServer().then((response) => {
        if (response.status === 200) {
          let dateTime = new Date(convertDate(response.data.result));
          const serverDate = currentDateV2(dateTime);
          setDataChiNgoaiLe((prev) => ({
            ...prev,
            ngaythuchi: serverDate,
          }));
        }
      });
    }

    dataChiNgoaiLe.isPhanBoChiPhi = phanBo;
    dataChiNgoaiLe.soThang = soThang;
    dataChiNgoaiLe.tuThang = tuThang;
    dataChiNgoaiLe.tuNam = tuNam;

    const newPhanBoData = Array.from({ length: soThang }, (_, i) => ({
      thang: ((Number(tuThang) + i - 1) % 12) + 1,
      nam: Number(tuNam) + Math.floor((Number(tuThang) + i - 1) / 12),
      sotien: Math.floor(dataChiNgoaiLe.sotien / soThang) || 0,
    }));

    setPhanBoData(newPhanBoData);

    console.log("phanBoData (mới tính toán):", newPhanBoData);
  }, [soThang, tuThang, tuNam, dataChiNgoaiLe.sotien]);

  useEffect(() => {
    dataChiNgoaiLe.dataPhanBo = phanBoData;
    console.log("Dữ liệu cập nhật:", dataChiNgoaiLe.dataPhanBo);
  }, [phanBoData]);

  //Set Data khi Update trường dữ liệu
  const updateTextValue = (field) => (e) => {
    setDataChiNgoaiLe({
      ...dataChiNgoaiLe,
      [field]: e.target.value,
    });
    if (e.target.value === "") {
      setErrors1({
        ...errors1,
        nguoinop: "Nhập tên người nhận",
      });
    } else {
      setErrors1({
        ...errors1,
        nguoinop: "",
      });
    }
  };

  //Set Data khi Update trường dữ liệu
  const updateTextValue1 = (field) => (e) => {
    setDataChiNgoaiLe({
      ...dataChiNgoaiLe,
      [field]: e.target.value,
    });
    if (e.target.value === "") {
      setErrors3({
        ...errors3,
        ghichu: "Nhập ghi chú",
      });
    } else {
      setErrors3({
        ...errors3,
        ghichu: "",
      });
    }
  };
  const onChangeNumber = (field) => (evt) => {
    setDataChiNgoaiLe({
      ...dataChiNgoaiLe,
      [field]: convertToNumber(evt.target.value),
    });
    if (evt.target.value === "") {
      setErrors2({
        ...errors2,
        sotien: "Nhập tiền",
      });
    } else if (evt.target.value === 0) {
      setErrors2({
        ...errors2,
        sotien: "Nhập tiền",
      });
    } else {
      setErrors2({
        ...errors2,
        sotien: "",
      });
    }
  };

  const onChangeDate = (field) => (evt) => {
    setDataChiNgoaiLe({
      ...dataChiNgoaiLe,
      [field]: formatDayMonth(evt),
    });
    if (evt === "null") {
      setErrors4({
        ...errors4,
        ngaythuchi: "Nhập ngày chi",
      });
    } else {
      setErrors4({
        ...errors4,
        ngaythuchi: "",
      });
    }
  };

  const dataOption = {
    loaiPhieuOption: [],
    nguoiTaoOption: [],
  };

  const [loaiPhieuChi, setLoaiPhieuChi] = useState(dataOption.loaiPhieuOption);
  const [listUser, setListUser] = useState(dataOption.nguoiTaoOption);
  useEffect(() => {
    if (props.thuchiId > 0) {
      QuanLyThuChiNgoaiLeApi.chiTietThuChiNgoaiLe(props.thuchiId).then(
        (response) => {
          // // alert(response.data.ThongTinTaiSan.Code);
          setDataChiNgoaiLe({
            ...dataChiNgoaiLe,
            thuchiId: props.thuchiId,
            ngaythuchi: response.data.Time,
            nhanviennhantien: response.data.UserName,
            nguoinop: response.data.Name,
            sotien: response.data.Value * -1,
            loaiphieu: response.data.LoaiThuChiNgoaiLe,
            ghichu: response.data.Note,
            isLoiNhuan: response.data.IsLoiNhuan,
          });
        },
      );
      console.log("dataChiNgoaiLe", dataChiNgoaiLe);
    }

    QuanLyThuChiNgoaiLeApi.loaiThuChi1(2).then((response) => {
      const dataComboReturn = response.data.map((item) => ({
        value: item.value,
        label: item.label,
      }));
      setLoaiPhieuChi(dataComboReturn);
    });
    userApi.combo().then((response) => {
      const dataComboUser = response.data.map((item) => ({
        value: item.value,
        label: item.label,
      }));
      setListUser(dataComboUser);
    });
  }, []);

  //Thông báo
  const validateName = (nguoinop) => {
    const expression = /(\w.).+/i;
    return expression.test(String(nguoinop).toLowerCase());
  };

  const initErrors = { nhanviennhantien: "" };
  const [errors, setErrors] = useState(initErrors);
  const initErrors1 = { nguoinop: "" };
  const [errors1, setErrors1] = useState(initErrors1);
  const initErrors2 = { sotien: "" };
  const [errors2, setErrors2] = useState(initErrors2);
  const initErrors3 = { ghichu: "" };
  const [errors3, setErrors3] = useState(initErrors3);
  const initErrors4 = { ngaythuchi: "" };
  const [errors4, setErrors4] = useState(initErrors4);
  const initErrors5 = { loaiphieu: "" };
  const [errors5, setErrors5] = useState(initErrors5);

  const onSubmit = () => {
    if (dataChiNgoaiLe.nguoinop === "") {
      setErrors1({
        ...errors1,
        nguoinop: "Nhập tên người nhận",
      });
      return;
    } else if (!validateName(dataChiNgoaiLe.nguoinop)) {
      setErrors1({
        ...errors1,
        nguoinop: "Tên người nhận phải có ít nhất 2 từ",
      });
      return;
    } else if (
      dataChiNgoaiLe.nhanviennhantien === listUser[0].value ||
      dataChiNgoaiLe.nhanviennhantien === ""
    ) {
      setErrors({
        ...errors,
        nhanviennhantien: "Chọn nhân viên đưa tiền",
      });
      return;
    } else if (dataChiNgoaiLe.sotien === 0 || dataChiNgoaiLe.sotien === "") {
      setErrors2({
        ...errors2,
        sotien: "Nhập tiền",
      });
      return;
    } else if (dataChiNgoaiLe.loaiphieu === 0) {
      setErrors5({
        ...errors5,
        loaiphieu: "Chọn loại phiếu",
      });
      return;
    } else if (dataChiNgoaiLe.ghichu === "") {
      setErrors3({
        ...errors3,
        ghichu: "Nhập ghi chú",
      });
      return;
    } else if (
      dataChiNgoaiLe.ngaythuchi === "null" ||
      dataChiNgoaiLe.ngaythuchi === null ||
      dataChiNgoaiLe.ngaythuchi === ""
    ) {
      setErrors4({
        ...errors4,
        ngaythuchi: "Nhập ngày chi",
      });
      return;
    } else if (props.thuchiId > 0) {
      setIsSubmit(true);
      QuanLyThuChiNgoaiLeApi.editChiNgoaiLe(
        dataChiNgoaiLe.thuchiId,
        dataChiNgoaiLe.ngaythuchi,
        dataChiNgoaiLe.nhanviennhantien,
        dataChiNgoaiLe.nguoinop,
        dataChiNgoaiLe.sotien,
        dataChiNgoaiLe.loaiphieu,
        dataChiNgoaiLe.ghichu,
        dataChiNgoaiLe.isLoiNhuan,
      ).then((response) => {
        setIsSubmit(false);
        if (response.data.Error === 1) {
          pushNotification(response.data.Message, "error", "TOP_CENTER", 1000);
          return;
        } else {
          // showAlert();
          pushNotification(
            "Cập nhật phiếu chi thành công.",
            "success",
            "TOP_CENTER",
            1000,
          );
          props.onHide();
          dispatch(getListQuanLyThuChiNgoaiLe(dataSearch));
        }
      });
    } else {
      setIsSubmit(true);
      QuanLyThuChiNgoaiLeApi.addChiNgoaiLe(
        dataChiNgoaiLe.ngaythuchi,
        dataChiNgoaiLe.nhanviennhantien,
        dataChiNgoaiLe.nguoinop,
        dataChiNgoaiLe.sotien,
        dataChiNgoaiLe.loaiphieu,
        dataChiNgoaiLe.ghichu,
        dataChiNgoaiLe.isLoiNhuan,
        dataChiNgoaiLe.isPhanBoChiPhi,
        dataChiNgoaiLe.soThang,
        dataChiNgoaiLe.tuThang,
        dataChiNgoaiLe.tuNam,
        dataChiNgoaiLe.dataPhanBo,
      ).then((response) => {
        setIsSubmit(false);
        if (response.data.Error === 1) {
          pushNotification(response.data.Message, "error", "TOP_CENTER", 1000);
          return;
        } else {
          // showAlert();
          pushNotification(
            "Thêm mới phiếu chi thành công",
            "success",
            "TOP_CENTER",
            1000,
          );
          props.onHide();
          dispatch(getListQuanLyThuChiNgoaiLe(dataSearch));
        }
      });
    }
  };

  return (
    <Modal
      {...props}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <img src="/app-assets/images/icon-logo-quan-ly-thu-chi.png" />
          </span>{" "}
          {props.thuchiId > 0 ? "Sửa" : "Tạo"} phiếu chi
        </h4>

        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <form class="form tat-toan">
          <div class="form-body">
            <div class="card collapse-icon accordion-icon-rotate">
              <div
                id="headingCollapse5311"
                class="card-header border-info"
                href="#collapse5311"
                aria-expanded="true"
                aria-controls="collapse5311"
              >
                <a class="card-title lead info collapsed" href={() => false}>
                  <h3>
                    {props.thuchiId > 0 ? "Sửa" : "Tạo"} phiếu chi ngoài lề
                  </h3>
                </a>
              </div>
              <div
                id="collapse5311"
                aria-labelledby="headingCollapse5311"
                class="card-collapse collapse show"
                aria-expanded="true"
              >
                <div class="card-content">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label className="label-control color7-bold">
                            Ngày chi <span className="canh-bao-red">*</span>
                          </label>
                          <DateTimePicker
                            value={convertDate(dataChiNgoaiLe.ngaythuchi)}
                            name="ngaythuchi"
                            onChange={onChangeDate("ngaythuchi")}
                          ></DateTimePicker>
                          {errors4.ngaythuchi && (
                            <span className="canh-bao-red">
                              {errors4.ngaythuchi}
                            </span>
                          )}
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="form-group">
                          <label className="label-control color7-bold">
                            Nhân viên đưa tiền{" "}
                            <span className="canh-bao-red">*</span>
                          </label>
                          <select
                            name="nhanviennhantien"
                            className="selectBox form-control input-sm"
                            value={dataChiNgoaiLe.nhanviennhantien}
                            onChange={updateDropdown("nhanviennhantien")}
                          >
                            {listUser &&
                              listUser.map((item, idx) => (
                                <option
                                  key={"objComboStore1" + idx}
                                  value={item.value}
                                >
                                  {item.label}
                                </option>
                              ))}
                          </select>
                          {errors.nhanviennhantien && (
                            <span className="canh-bao-red">
                              {errors.nhanviennhantien}
                            </span>
                          )}
                        </div>
                      </div>

                      <div class="col-md-4">
                        <TextInputOnRow
                          labelClass="label-control color7-bold"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Người nhận"
                          inputProps={{
                            name: "nguoinop",
                            // ref: NguoiNhan,
                            onChange: updateTextValue("nguoinop"),
                            value: dataChiNgoaiLe.nguoinop,
                          }}
                        ></TextInputOnRow>
                        {errors1.nguoinop && (
                          <span className="canh-bao-red">
                            {errors1.nguoinop}
                          </span>
                        )}
                      </div>

                      <div class="col-md-4">
                        <TextInputOnRow
                          labelClass="label-control color7-bold"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Số tiền"
                          starRed="*"
                          inputProps={{
                            name: "sotien",
                            onChange: onChangeNumber("sotien"),
                            value: formatNumber(dataChiNgoaiLe.sotien),
                          }}
                        ></TextInputOnRow>
                        {errors2.sotien && (
                          <span className="canh-bao-red">{errors2.sotien}</span>
                        )}
                      </div>

                      <div class="col-md-4">
                        <div class="form-group">
                          <label className="label-control color7-bold">
                            Loại phiếu <span className="canh-bao-red">*</span>
                          </label>
                          <select
                            name="loaiphieu"
                            className="selectBox form-control input-sm"
                            value={dataChiNgoaiLe.loaiphieu}
                            onChange={updateDropdown("loaiphieu")}
                          >
                            {loaiPhieuChi &&
                              loaiPhieuChi.map((item, idx) => (
                                <option
                                  key={"objComboStore1" + idx}
                                  value={item.value}
                                >
                                  {item.label}
                                </option>
                              ))}
                          </select>
                          {errors5.loaiphieu && (
                            <span className="canh-bao-red">
                              {errors5.loaiphieu}
                            </span>
                          )}
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="form-group">
                          <label className="label-control color7-bold">
                            Ghi chú <span className="canh-bao-red">*</span>
                          </label>
                          <textarea
                            rows="1"
                            class="form-control input-sm text-era"
                            name="comment"
                            placeholder="Ghi chú"
                            value={dataChiNgoaiLe.ghichu}
                            onChange={updateTextValue1("ghichu")}
                          ></textarea>
                          {errors3.ghichu && (
                            <span className="canh-bao-red">
                              {errors3.ghichu}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>

                    {usePhanBoChiPhi && (
                      <div className="row">
                        <div class="col-md-4">
                          <div className="form-group">
                            <label className="label-control color7-bold">
                              Tính vào lợi nhuận
                            </label>
                            <input
                              type="checkbox"
                              checked={dataChiNgoaiLe.isLoiNhuan}
                              onChange={handleCheckboxChange}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    {!(props.thuchiId > 0) && usePhanBoChiPhi && (
                      <div>
                        <div className="row">
                          <div class="col-md-2">
                            <div className="form-group">
                              <label className="label-control color7-bold">
                                Phân bổ chi phí
                              </label>
                              <input
                                type="checkbox"
                                checked={phanBo}
                                onChange={(e) =>
                                  setPhanBoChiPhi(e.target.checked)
                                }
                              />
                            </div>
                          </div>
                          {phanBo && (
                            <div class="col-md-10">
                              <div style={{ float: "left" }}>
                                <label
                                  className="label-control color7-bold"
                                  style={{ float: "left", paddingTop: "3px" }}
                                >
                                  Cho&nbsp;
                                </label>
                                <input
                                  type="number"
                                  className="form-control input-sm"
                                  style={{
                                    width: "70px",
                                    textAlign: "right",
                                    border: "1px solid #CACFE7",
                                    float: "left",
                                    margin: "0px 10px 0px 10px",
                                  }}
                                  value={tempValue}
                                  onChange={(e) => setTempValue(e.target.value)}
                                  onBlur={() =>
                                    setSoLuongPhanBoChiPhi(tempValue)
                                  }
                                />
                                <label
                                  className="label-control color7-bold"
                                  style={{ float: "left", paddingTop: "3px" }}
                                >
                                  &nbsp;tháng
                                </label>
                              </div>
                              <div style={{ float: "left" }}>
                                <label
                                  className="label-control color7-bold"
                                  style={{ float: "left", paddingTop: "3px" }}
                                >
                                  →&nbsp;&nbsp;Bắt đầu từ tháng&nbsp;
                                </label>
                                <select
                                  className="form-control input-sm"
                                  style={{
                                    width: "70px",
                                    border: "1px solid #CACFE7",
                                    float: "left",
                                    margin: "0px 10px 0px 10px",
                                  }}
                                  value={tuThang}
                                  // onChange={(e) => setTuThang(e.target.value)}
                                  onChange={(e) => {
                                    setTuThang(e.target.value);
                                    setSoLuongPhanBoChiPhi(
                                      dataChiNgoaiLe.soThang,
                                    ); // Cập nhật dữ liệu ngay khi thay đổi
                                  }}
                                >
                                  {[...Array(12).keys()].map((month) => (
                                    <option key={month + 1} value={month + 1}>
                                      {month + 1}
                                    </option>
                                  ))}
                                </select>
                                <label
                                  className="label-control color7-bold"
                                  style={{ float: "left", paddingTop: "3px" }}
                                >
                                  &nbsp;năm&nbsp;
                                </label>
                                <select
                                  className="form-control input-sm"
                                  style={{
                                    width: "90px",
                                    border: "1px solid #CACFE7",
                                    float: "left",
                                  }}
                                  value={tuNam}
                                  onChange={(e) => {
                                    setTuNam(e.target.value);
                                    setSoLuongPhanBoChiPhi(
                                      dataChiNgoaiLe.soThang,
                                    ); // Cập nhật dữ liệu ngay khi thay đổi
                                  }}
                                >
                                  {[...Array(10).keys()].map((index) => (
                                    <option
                                      key={index}
                                      value={tuNam - 2 + index}
                                    >
                                      {tuNam - 2 + index}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="row">
                          {Number(soThang) > 0 &&
                            [...Array(Number(soThang))].map((_, index) => {
                              const thangTinhToan =
                                ((Number(tuThang) + index - 1) % 12) + 1; // Tính tháng hợp lệ
                              const namTinhToan =
                                Number(tuNam) +
                                Math.floor((Number(tuThang) + index - 1) / 12); // Tính năm

                              return (
                                <ThangNamPhanBo
                                  key={index}
                                  thang={thangTinhToan}
                                  tunam={namTinhToan}
                                  initialValue={dataChiNgoaiLe.sotien}
                                  soThang={Number(soThang)}
                                  onChange={updatePhanBoData}
                                />
                              );
                            })}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer ">
        {/* <a
          className="btn btn-new-main btn-closenew"
          data-dismiss="modal"
          href={() => false}
          onClick={props.onHide}
        >
          <span>
            <i className="mdi mdi-close"></i>
          </span>
           &nbsp; Đóng &nbsp;
        </a> */}
        <button
          type="button"
          class="btn btn-new-main btn-closenew"
          href={() => false}
          onClick={props.onHide}
        >
          <span>
            <i class="mdi mdi-close"></i>
          </span>
          &nbsp; Đóng &nbsp;
        </button>
        {isSubbmit == false && (
          <>
            <button
              className="btn btn-new-main btn-checknew"
              href={() => false}
              onClick={onSubmit}
            >
              <span>
                <img src="/app-assets/images/icon-save-v2-white.png" />
              </span>{" "}
              {props.thuchiId > 0 ? "Xác nhận" : "Tạo phiếu chi"}
              &nbsp;
            </button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};
